(function () {
  'use strict';
  const profiles = window.VinpopTasteProfile;
  if (!profiles) return;

  const root = document.querySelector('[data-shop-guide]');
  if (!root) return;
  const params = new URLSearchParams(location.search);
  if (params.has('source_product') || params.has('main-product')) {
    root.hidden = true;
    document.documentElement.setAttribute('data-vp-guide-off', '');
    return;
  }
  const copy = JSON.parse(root.querySelector('[data-guide-copy]').textContent);
  const result = root.querySelector('[data-guide-result]');
  const clear = root.querySelector('[data-guide-clear]');
  const bar = root.querySelector('[data-guide-bar]');
  const buy = root.querySelector('[data-guide-buy]');
  const barError = root.querySelector('[data-guide-bar-error]');
  const buyLabel = buy.textContent;
  let selection = [];
  // A native sort or sort_by link means the customer chose another order: the profile stays stored but is not applied.
  // The filter drawer's Apply also serialises the default sort (sort_by=most-relevant on Wines), which is not a choice.
  const chosenSort = sort => !!sort && sort !== (root.dataset.defaultSort || '');
  let suppressed = chosenSort(params.get('sort_by'));
  const money = cents => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    } catch (error) {
      return '€' + (cents / 100).toFixed(2);
    }
  };

  // "N% match" + where the number comes from (decision Adrien 2026-10-23): a source line and a short
  // explanation, always shown since 2026-10-25. Quiz badges are built here; rating badges are built with the
  // same markup by assets/vinpop-personal-shop.js renderBadge(). Keep both in sync (classes).
  const matchBadge = window.VinpopGuidePrompts.matchBadge;

  // Quiz scores are only used before the account has any wine ratings.
  function paintBadges(cards, profile) {
    let painted = 0;
    for (const card of cards) {
      card.querySelector('[data-guide-match]')?.remove();
      const score = profile?.scores?.[card.dataset.productId];
      const body = card.querySelector('[data-wine-card-body]');
      if (!body || !Number.isFinite(score)) continue;
      const tip = copy.explanation ? profiles.personalNotice(profile, card.dataset.productId, copy.explanation) : '';
      const badge = matchBadge(copy.match.replace('__PCT__', score), copy.quiz_source, tip || copy.quiz_tip,
        'vp-match-tip-' + card.dataset.productId);
      badge.dataset.guideMatch = '';
      badge.dataset.source = 'quiz';
      body.prepend(badge);
      painted++;
    }
    return painted;
  }

  // Line under the top 3: exact delivery date only. The v5 first-order free-delivery saving
  // (vinpop-first-order-shipping.js, automatic code) does not exist on v4 and must not be announced here.
  function offerLine() {
    const delivery = window.VinpopDeliveryDate;
    const lang = String(document.documentElement.lang || 'en').slice(0, 2);
    const date = delivery ? delivery.label(delivery.deliveryDate(), lang) : '';
    // First order delivered free from 3 bottles (2026-10-26): shown before the delivery date.
    return [copy.offer_free || '', date ? copy.offer_date.replace('__DATE__', date) : ''].filter(Boolean).join(' ');
  }

  // Fixed bar = the customer's selection (decision Adrien 2026-10-25). The first three ranked wines shown (after
  // native filters, in stock, with a single-bottle variant) start at 1 bottle, every other wine at 0; the card
  // steppers change it and the bar follows. Cards lose their own Add to cart while the bar is shown (CSS on
  // html[data-vp-guide-bar]). The top 3 get a tinted background and a heading separates them from the rest.
  // Quantities the customer chose survive a re-sort or re-filter of the grid (keyed by product id).
  const chosen = new Map();
  const MIN_BOTTLES = 3;
  const demoAllowed = () => {
    const personal = window.VinpopPersonalShop;
    return !personal?.pending && !personal?.failed && !personal?.active;
  };
  const variantOf = card => card.querySelector('[data-vp-variant]');
  function eligible(card) {
    const tile = variantOf(card);
    return card.style?.display !== 'none' && !card.hasAttribute('data-personal-hidden') &&
      !!tile && !!tile.dataset.vpVariant && tile.dataset.vpAvailable === 'true';
  }

  // The stepper is an Alpine island hydrated when it scrolls into view: data-qty / data-min feed its x-data,
  // and an already hydrated one is updated through Alpine directly.
  function setQuantity(card, quantity, min) {
    const step = card.querySelector('.vp-step');
    if (!step) return;
    step.dataset.qty = quantity;
    step.dataset.min = min;
    if (step._x_dataStack && window.Alpine) Object.assign(window.Alpine.$data(step), { min, quantity });
  }

  function paintBar(cards, hasScore) {
    const top = cards.filter(card => hasScore(card) && eligible(card)).slice(0, 3);
    if (top.length < 3) return hideBar(cards);
    markTop(top);
    for (const card of cards) {
      const id = card.dataset.productId;
      setQuantity(card, chosen.has(id) ? chosen.get(id) : top.includes(card) ? 1 : 0, 0);
    }
    bar.hidden = false;
    document.documentElement.setAttribute('data-vp-guide-bar', '');
    paintSelection();
  }

  var lastSelectionIsTop; // var without a value: hoisted, never reset if paintSelection() ran first
  function paintSelection() {
    const grid = document.querySelector('#facets-results > ul.grid');
    const cards = grid ? [...grid.children].filter(card => card.hasAttribute('data-product-id')) : [];
    selection = cards.filter(eligible).map(card => {
      const tile = variantOf(card);
      const step = card.querySelector('.vp-step');
      return { id: Number(tile.dataset.vpVariant), price: Number(tile.dataset.vpPrice) || 0,
        quantity: Number(step?.dataset.qty) || 0, top: card.hasAttribute('data-guide-top') };
    }).filter(wine => wine.quantity > 0);
    const bottles = selection.reduce((sum, wine) => sum + wine.quantity, 0);
    const isTop = bottles === 3 && selection.every(wine => wine.top && wine.quantity === 1);
    root.querySelector('[data-guide-bar-label]').textContent = isTop ? copy.bar_top
      : !bottles ? copy.bar_empty : (bottles === 1 ? copy.bar_one : copy.bar_many.replace('__N__', bottles));
    root.querySelector('[data-guide-bar-total]').textContent = bottles
      ? '· ' + money(selection.reduce((sum, wine) => sum + wine.price * wine.quantity, 0)) : '';
    // Minimum order 3 bottles (OFFRE_ET_TEXTES.md): below it the delivery line says how many are missing.
    const missing = bottles ? Math.max(0, MIN_BOTTLES - bottles) : 0;
    const offer = root.querySelector('[data-guide-bar-offer]');
    // Taste guarantee (2026-10-26): only the quiz top 3 ordered as is is covered, so the line shows only then.
    offer.textContent = missing ? (missing === 1 ? copy.bar_missing_one : copy.bar_missing.replace('__N__', missing))
      : [offerLine(), isTop ? copy.top_guarantee || '' : ''].filter(Boolean).join(' ');
    lastSelectionIsTop = isTop;
    offer.classList.toggle('is-missing', !!missing);
    buy.disabled = bottles < MIN_BOTTLES;
  }

  function hideBar(cards) {
    bar.hidden = true;
    document.documentElement.removeAttribute('data-vp-guide-bar');
    markTop([]);
    (cards || document.querySelectorAll('[data-product-id]')).forEach(card => {
      if (card.querySelector('.vp-step[data-min]')?.dataset.min === '0') setQuantity(card, 1, 1);
    });
  }

  function markTop(cards) {
    document.querySelectorAll('[data-guide-top]').forEach(card => card.removeAttribute('data-guide-top'));
    document.querySelectorAll('[data-guide-rest], [data-guide-demo]').forEach(node => node.remove());
    cards.forEach(card => card.setAttribute('data-guide-top', ''));
    const last = cards[cards.length - 1];
    if (!last) return;
    if (demoAllowed()) {
      const demo = document.createElement('li');
      demo.className = 'vp-guide-demo';
      demo.dataset.guideDemo = '';
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'vp-guide-demo__btn';
      trigger.dataset.vpDemoOpen = '';
      trigger.dataset.demoPlacement = 'inline';
      trigger.textContent = copy.demo_cta;
      demo.appendChild(trigger);
      cards[0].before(demo);
      window.VinPopTracking?.trackDemoCtaShown({ placement: 'inline' });
    }
    const rest = document.createElement('li');
    rest.className = 'vp-guide-rest';
    rest.dataset.guideRest = '';
    const title = document.createElement('p');
    title.className = 'vp-guide-rest__title';
    title.textContent = copy.rest_title;
    rest.appendChild(title);
    last.after(rest);
  }

  // Once the customer has scrolled past the top 3 (the "rest" heading is in the upper half of the screen), the demo
  // button floats in the middle of the screen (Adrien 2026-10-25). Once per visit: closing it or opening the demo
  // ends it; scrolling back above the top 3 hides it again.
  let float = null;
  let floatDone = false;
  try { floatDone = sessionStorage.getItem('vp_demo_float_done') === '1'; } catch (error) { /* storage blocked */ }
  function endFloat() {
    floatDone = true;
    try { sessionStorage.setItem('vp_demo_float_done', '1'); } catch (error) { /* storage blocked */ }
    if (float) float.hidden = true;
  }
  function buildFloat() {
    float = document.createElement('div');
    float.className = 'vp-guide-demo-float';
    float.hidden = true;
    const open = document.createElement('button');
    open.type = 'button';
    open.className = 'vp-guide-demo__btn';
    open.dataset.vpDemoOpen = '';
    open.dataset.demoPlacement = 'float';
    open.textContent = copy.demo_cta;
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'vp-guide-demo-float__close';
    close.setAttribute('aria-label', copy.demo_close);
    close.textContent = '×';
    close.addEventListener('click', endFloat);
    float.append(open, close);
    document.body.appendChild(float);
  }
  let floatTick = false;
  function syncFloat() {
    floatTick = false;
    const rest = document.querySelector('[data-guide-rest]');
    const show = demoAllowed() && !floatDone && !!rest && !bar.hidden && !document.documentElement.hasAttribute('data-vp-demo-active') &&
      rest.getBoundingClientRect().top < innerHeight / 2;
    if (show && !float) buildFloat();
    if (!float || float.hidden === !show) return;
    float.hidden = !show;
    if (show) window.VinPopTracking?.trackDemoCtaShown({ placement: 'float' });
    if (show) requestAnimationFrame(() => float.classList.add('is-in'));
    else float.classList.remove('is-in');
  }
  addEventListener('scroll', () => {
    if (floatTick) return;
    floatTick = true;
    requestAnimationFrame(syncFloat);
  }, { passive: true });
  document.addEventListener('click', event => {
    const opener = event.target.closest?.('[data-vp-demo-open]');
    if (!opener || !demoAllowed()) return;
    window.VinPopTracking?.trackDemoOpened({ placement: opener.dataset.demoPlacement });
    endFloat();
  });

  document.addEventListener('quantity-changed', event => {
    const card = event.target.closest?.('#facets-results [data-product-id]');
    if (!card || bar.hidden) return;
    const quantity = Math.max(0, Number(event.detail?.quantity) || 0);
    chosen.set(card.dataset.productId, quantity);
    const step = card.querySelector('.vp-step');
    if (step) step.dataset.qty = quantity;
    paintSelection();
  });

  const eyebrow = root.querySelector('[data-guide-eyebrow]');
  const retake = root.querySelector('[data-guide-retake]');
  const rate = root.querySelector('[data-guide-rate]');

  // Banner text for one state. quiz = profile only; rated = ratings drive the scores (learning indicator).
  function paintBanner(state, title, lead, eyebrowText) {
    root.dataset.guideState = state;
    eyebrow.textContent = eyebrowText;
    eyebrow.hidden = !eyebrowText;
    root.querySelector('[data-guide-title]').textContent = title;
    root.querySelector('[data-guide-lead]').textContent = lead;
    retake.hidden = state !== 'quiz';
    clear.hidden = state !== 'quiz';
    rate.hidden = state !== 'rated';
    result.hidden = false;
  }

  function hideGuide() {
    result.hidden = true;
    clear.hidden = true;
    hideBar();
    document.querySelectorAll('[data-guide-match]').forEach(badge => badge.remove());
  }

  function applyRanking() {
    const profile = profiles.load();
    if (!profile) return paintTeaser();
    if (suppressed) return;
    hideTeaser();
    document.documentElement.setAttribute('data-vp-guide-ready', '');
    const grid = document.querySelector('#facets-results > ul.grid');
    if (!grid) return;
    const order = new Map(profile.ids.map((id, index) => [id, index]));
    const cards = [...grid.children].filter(card => card.hasAttribute('data-product-id'));
    const catalog = window.shopCatalog || {};
    // The chosen colour leads, like the home result rail; wines of the other colour follow in their own order.
    const offColour = card => {
      const colour = profiles.colourOf(catalog[card.dataset.productId]?.wineColor);
      return profile.colour !== 'both' && colour && colour !== profile.colour ? 1 : 0;
    };
    cards.sort((a, b) => offColour(a) - offColour(b) ||
      (order.get(a.dataset.productId) ?? Infinity) - (order.get(b.dataset.productId) ?? Infinity));
    for (const card of cards) grid.appendChild(card);
    const missing = cards.some(card => !order.has(card.dataset.productId));
    const name = copy.families[profile.family];
    paintBanner('quiz', copy.set_title, copy.set_lead + (missing ? ' ' + copy.unmeasured : ''),
      name ? copy.title.replace('__NAME__', name) : copy.eyebrow);
    paintBadges(cards, profile);
    paintBar(cards, card => profile.scores?.[card.dataset.productId] != null);
  }

  // Rated customers get one uninterrupted grid, with the native card purchase controls.
  function applyRated() {
    const personal = window.VinpopPersonalShop;
    if (!personal?.active || !personal?.ready) return;
    hideGuide();
    hideTeaser();
    root.dataset.guideState = 'rated';
    root.hidden = true;
  }

  // The selection to cart, through the standard Shopify cart endpoint, then the cart page.
  buy.addEventListener('click', async () => {
    if (!selection.length || buy.disabled) return;
    const base = (window.Shopify?.routes?.root || '/');
    buy.disabled = true;
    buy.textContent = copy.adding;
    barError.hidden = true;
    try {
      const response = await fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        // Quiz top 3 ordered as is: private line properties mark the bottles covered by the taste guarantee.
        body: JSON.stringify({ items: selection.map(wine => lastSelectionIsTop
          ? { id: wine.id, quantity: wine.quantity, properties: { _selection_source: 'quiz_top3', _taste_guarantee: '1' } }
          : { id: wine.id, quantity: wine.quantity }) })
      });
      if (!response.ok) throw new Error('cart_add_' + response.status);
      location.href = base + 'cart';
    } catch (error) {
      console.error('VinpopShopGuide: top 3 could not be added', error);
      barError.textContent = copy.error;
      barError.hidden = false;
      buy.disabled = false;
      buy.textContent = buyLabel;
    }
  });

  // Teaser mode (decision Adrien 2026-10-23 11:33): no stored profile -> three prompts to take the quiz.
  // 1. A compact banner above the grid (replaces the row "Guide me" button, hidden via html[data-vp-guide-ready]).
  // 2. A locked badge "? % match" on every tile, where the real "N% match" will appear; click opens a small
  //    popover with the quiz link. 3. A teaser tile at the 3rd position of the grid with an EXAMPLE match pill.
  // All percentages shown here are labelled as examples; real ones only come from a stored profile.
  const teaser = root.querySelector('[data-guide-teaser]');
  const quizUrl = root.dataset.quizUrl || '/pages/taste-profile';
  // The colour word follows the native colour filter (EN and NL facet values), else "every wine".
  function shownColour() {
    const values = params.getAll('filter.p.m.custom.product_type').join(' ').toLowerCase();
    const white = /white|witte/.test(values), red = /red|rode/.test(values);
    return white && !red ? 'white' : red && !white ? 'red' : 'all';
  }
  function closeLocks(except) {
    window.VinpopGuidePrompts.closeLocks(except);
  }
  function hideTeaser() {
    if (teaser) teaser.hidden = true;
    closeLocks();
    document.querySelectorAll('[data-guide-lock-wrap], [data-guide-teaser-card]').forEach(node => node.remove());
  }
  function paintTeaser() {
    const grid = document.querySelector('#facets-results > ul.grid');
    if (teaser) {
      teaser.querySelector('[data-guide-teaser-title]').textContent = copy['teaser_title_' + shownColour()];
      teaser.hidden = false;
    }
    document.documentElement.setAttribute('data-vp-guide-ready', '');
    if (!grid) return;
    const cards = [...grid.children].filter(card => card.hasAttribute('data-product-id'));
    window.VinpopGuidePrompts.paint(grid, cards, '[data-wine-card-body]', copy,
      quizUrl, 'vp-guide-lock-pop-', 'li');
  }
  clear.addEventListener('click', () => {
    profiles.clear();
    location.reload();
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-native-sort-apply]') || suppressed) return;
    suppressed = true;
    hideGuide();
  }, true);
  // Do not fall back to a quiz while ratings are loading, unavailable or present (including Dislike-only).
  function guideState() {
    const personal = window.VinpopPersonalShop;
    if (personal?.pending) return 'pending';
    if (personal?.failed) return 'unavailable';
    return personal?.active && personal?.ready ? 'rated' : 'profile';
  }
  // Rated mode waits a tick so VinpopPersonalShop.apply(), bound to the same event, has sorted the grid first.
  const refreshGuide = () => {
    const state = guideState();
    if (state === 'rated') setTimeout(applyRated, 0);
    else if (state === 'profile') applyRanking();
  };
  document.addEventListener('shapes:section:hasmutated', refreshGuide);
  document.addEventListener('vinpop:shop-facets-applied', refreshGuide);
  function syncPersonalPriority() {
    const state = guideState();
    if (!demoAllowed() && float) float.hidden = true;
    root.hidden = state === 'pending' || state === 'unavailable';
    document.documentElement.toggleAttribute('data-vp-guide-off', state !== 'profile');
    if (state === 'pending' || state === 'unavailable') {
      hideGuide();
      hideTeaser();
      document.documentElement.removeAttribute('data-vp-guide-ready');
    } else if (state === 'rated') {
      hideGuide();
      applyRated();
    } else applyRanking();
  }
  document.addEventListener('vinpop:personal-shop', syncPersonalPriority);
  syncPersonalPriority();
})();
